import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { ChatService } from '../chat.service';
import { ModalService } from '@app/modal/modal.service';
import { StartRainTriviaModalComponent } from '@app/modals/start-rain-trivia-modal/start-rain-trivia-modal.component';
import { StartTriviaModalComponent } from '@app/modals/start-trivia-modal/start-trivia-modal.component';
import { NotificationService } from '@app/notification/notification.service';
import { ToggleDropdownDirective } from '@shared/directives/toggle-dropdown.directive';
import { DropdownItemComponent } from '@shared/dropdown/dropdown-item.component';
import { DropdownComponent } from '@shared/dropdown/dropdown.component';
import { IconComponent } from '@shared/icon/icon.component';
import { SliderComponent } from '@shared/slider/slider.component';
import { UIService } from '@shared/ui.service';

@Component({
  selector: 'app-chat-top-bar',
  templateUrl: './chat-top-bar.component.html',
  styleUrls: ['./chat-top-bar.component.scss'],
  host: {
    '[class.trimmed]': ' (uiService.screenSize === "Large" || uiService.screenSize === "XLarge" || uiService.screenSize === "Unknown") && isTrimmed()',
  },
  imports: [ToggleDropdownDirective, NgClass, IconComponent, DropdownComponent, DropdownItemComponent, SliderComponent],
})
export class ChatTopBarComponent {
  constructor(public uiService: UIService, private modalService: ModalService, public notificationService: NotificationService, public chatService: ChatService) {}

  onItemSelect(item: string) {
    switch (item) {
      case 'trivia':
        this.modalService.open(StartTriviaModalComponent);
        break;
      case 'trivia-rain':
        this.modalService.open(StartRainTriviaModalComponent);
        break;
      case 'sound':
        this.uiService.setVolume(this.uiService.volume === 1 ? 0 : 1);
        break;
      case 'bet-notif':
        this.notificationService.setBetNotifications(!this.notificationService.betNotifications);
        break;
      case 'battle-spin':
        this.uiService.setWheelVersion(this.uiService.wheelVersion === '1' ? '2' : '1');
        break;
    }
  }

  isTrimmed() {
    return this.uiService.uiState().chat === 'trimmed';
  }

  isOpen() {
    return this.uiService.uiState().chat === 'open';
  }

  toggleChat() {
    if (this.uiService.screenSize === 'Large' || this.uiService.screenSize === 'XLarge' || this.uiService.screenSize === 'Unknown') {
      this.uiService.toggleUIState('chat', 'hidden');
    } else {
      this.uiService.toggleMobileUIState('chat');
    }
  }

  updateVolume(value: number): void {
    const normalizedValue = value / 100;
    this.uiService.setVolume(normalizedValue);
  }
}
